module.exports = __webpack_public_path__ + "assets/img/TOUCH.0c8a3a62.png";